import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import FuseUtils from '@fuse/utils';
import { Paper } from '@material-ui/core';
import ListSubheader from '@material-ui/core/ListSubheader';
import { makeStyles } from '@material-ui/core/styles';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FuseNavItem from '../FuseNavItem';

const useStyles = makeStyles((theme) => ({
  item: (props) => ({
    height: 40,
    width: 'calc(100% - 16px)',
    borderRadius: '0 20px 20px 0',
    paddingRight: 12,
    paddingLeft: props.itemPadding > 80 ? 80 : props.itemPadding,
    '&.active > .list-subheader-text': {
      fontWeight: 700,
    },
  }),
}));

function FuseNavVerticalGroup(props) {
  const userRole = useSelector(({ auth }) => auth.user.role);
  const dispatch = useDispatch();
  const { item, nestedLevel, dense } = props;
  const classes = useStyles({
    itemPadding: nestedLevel > 0 ? 40 + nestedLevel * 16 : 24,
  });
  const { t } = useTranslation('navigation');
  const [, setModalRelatorios] = useContext(GlobalContext).modalRelatorios;
  const [, setModal] = useContext(GlobalContext).modal;

  const FuseNavItemModais = (_item) => {
    return (
      <div
        onClick={(_) => {
          if (userRole.includes(_item.authority)) {
            if (_item?.financeiro) {
              setModal(_item?.financeiro);
            } else if (_item?.relatorio) {
              setModalRelatorios(_item?.relatorio);
            }
          }
        }}
      >
        <FuseNavItem
          key={_item.id}
          type={`vertical-${_item.type}`}
          item={_item}
          nestedLevel={nestedLevel}
          dense={dense}
        />
      </div>
    );
  };

  if (!FuseUtils.hasPermission(item.auth, userRole)) {
    return null;
  }

  return (
    <>
      <ListSubheader
        disableSticky
        className={clsx(classes.item, 'list-subheader flex items-center', !item.url && 'cursor-default')}
        onClick={(ev) => dispatch(Actions.navbarCloseMobile())}
        component={item.url ? NavLinkAdapter : 'li'}
        to={item.url}
        role="button"
      >
        <span className="list-subheader-text uppercase text-12">{item.translate ? t(item.translate) : item.title}</span>
      </ListSubheader>

      {item.gestao?.length && (
        <Paper elevation={0} className={classes.paper}>
          {item.gestao && (
            <ul className={clsx(classes.gestao, 'popper-navigation-list', dense && 'dense', 'px-0')}>
              {item.gestao.map((_item) =>
                _item?.relatorio || _item?.financeiro ? (
                  FuseNavItemModais(_item)
                ) : (
                  <FuseNavItem
                    key={_item.id}
                    type={`vertical-${_item.type}`}
                    item={_item}
                    nestedLevel={nestedLevel}
                    dense={dense}
                  />
                )
              )}
            </ul>
          )}
        </Paper>
      )}
      {item.cadastro?.length && (
        <Paper elevation={0} className={classes.paper}>
          {item.cadastro && (
            <ul className={clsx(classes.cadastro, 'popper-navigation-list', dense && 'dense', 'px-0')}>
              {item.cadastro.map((_item) => (
                <FuseNavItem
                  key={_item.id}
                  type={`vertical-${_item.type}`}
                  item={_item}
                  nestedLevel={nestedLevel}
                  dense={dense}
                />
              ))}
            </ul>
          )}
        </Paper>
      )}
    </>
  );
}

FuseNavVerticalGroup.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    children: PropTypes.array,
  }),
};

FuseNavVerticalGroup.defaultProps = {};

const NavVerticalGroup = withRouter(React.memo(FuseNavVerticalGroup));

export default NavVerticalGroup;
